export default {
  title: '會員列表',
  nickname: '暱稱',
  nicknamePlaceholder: '請輸入暱稱',
  level: '會員等級',
  email: '郵箱',
  emailPlaceholder: '請輸入郵箱',
  phone: '手機號',
  phonePlaceholder: '請輸入手機號',
  country: '所在國家',
  columns: {
    id: 'ID',
    nickname: '會員暱稱',
    level: '會員等級',
    country: '所在國家',
    email: '郵箱',
    phone: '手機號',
    registerTime: '註冊時間',
  },
  actions: {
    detail: '詳情',
    givePoints: '送積分',
    giveGrowth: '送成長值',
  },
  detail: {
    growthProgress: '成長值',
    growthHint: '距離下一級 {next} 還需 {remain} 成長值',
    baseInfo: '基礎信息',
    editProfile: '編輯資料',
    blacklist: '加入黑名單',
    asset: '資產信息',
    currentPoints: '當前積分',
    viewDetail: '查看明細',
    redPacketAmount: '紅包金額',
    scanStat: '掃碼統計',
    firstScanDate: '首次掃碼日期',
    lastScanTime: '最近掃碼時間',
    scanCount: '掃碼個數',
    tags: '標籤畫像',
    manageTags: '管理標籤',
    genderUnknown: '未知',
    genderMale: '男',
    genderFemale: '女',
    fields: {
      nickname: '暱稱',
      memberNo: '會員編號',
      realName: '真實姓名',
      gender: '性別',
      country: '國家',
      phone: '手機號',
      email: '郵箱',
      wechat: '微信號',
      birthday: '生日',
      lastLogin: '最後登入時間',
      registerTime: '註冊時間',
    },
  },
  modal: {
    codeRecord: {
      title: '掃碼明細',
      codeId: '碼ID',
      scanResult: '掃碼結果',
      scanTime: '掃碼時間',
      scanRegion: '掃碼地區',
    },
    pointsRecord: {
      title: '積分明細',
      type: '類型',
      dateRange: '日期範圍',
      totalPoints: '累計積分',
      consumedPoints: '已消耗積分',
      availablePoints: '可用積分',
      source: '積分來源',
      typeColumn: '類型',
      amount: '數量',
      date: '日期',
      income: '收入',
      expense: '支出',
    },
    redPacketRecord: {
      title: '紅包明細',
      type: '類型',
      amount: '金額',
      id: '紅包ID',
      status: '狀態',
      channel: '發放渠道',
      source: '紅包來源',
      receivedTime: '領取時間',
    },
    givePoints: {
      titlePoints: '送積分',
      titleGrowth: '送成長值',
      points: '積分',
      growth: '成長值',
      amountPlaceholder: '請輸入數量（支持負數）',
      amountHint: '輸入正數為發放，負數為扣減',
      amountRequired: '請輸入數量',
      remark: '備註',
      remarkPlaceholder: '請輸入備註',
    },
    blacklist: {
      title: '加入黑名單',
      confirmTitle: '確認將該會員加入黑名單？',
      warning: '加入黑名單後，該會員將無法再掃碼、領取紅包及參與活動。',
      tip: '此操作可在「黑名單管理」中移除。',
    },
  },
};
